import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import HomePage from './Pages/HomePage';
import ProjectDetailPage from './Pages/ProjectDetailPage';

function App() {
    return (
        <Router>
            <div className="main-wrapper">
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/project/:id" element={<ProjectDetailPage />} />
                    <Route path='*' element={
                                        <div className="container py-5 text-center">
                                            <div className="py-5">
                                                <h2>الصفحة غير موجودة</h2>
                                                <p className="mt-3">لم يتم العثور على الصفحة المطلوبة.</p>
                                                <Link to="/" className="btn btn-primary mt-3">العودة للصفحة الرئيسية</Link>
                                            </div>
                                        </div>} 

                    />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
}

export default App;